import { InMemoryCache } from '@apollo/client/cache';
import { relayStylePagination } from '@apollo/client/utilities';
import possibleTypesResult from '../graphql/generated/possible-types';

const mergeField = (existing: any, incoming: any) => ({
  ...existing,
  ...incoming,
});

export function configureApolloCache() {
  return new InMemoryCache({
    possibleTypes: possibleTypesResult.possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          circlesByOwningAccount: relayStylePagination(),
          listProgramsV2: relayStylePagination(),
          // The qa-agent chat history queries are paginated `PostConnection`s.
          // Without an explicit merge policy Apollo would warn about lost
          // cache data on every fetchMore/poll and intermittently drop pages
          // when scrolling up to load older messages. Key by everything
          // except the cursor (`after`) so that distinct conversations stay
          // in distinct cache entries.
          privatePosts: relayStylePagination(['userIds', 'filter']),
          userPosts: relayStylePagination([
            'userIds',
            'filter',
            'projectId',
            'cohortId',
          ]),
        },
      },
      User: {
        keyFields: ['userId'],
        fields: {
          profile: {
            merge: mergeField,
          },
        },
      },
      Circle: {
        fields: {
          membersConnection: relayStylePagination(),
          forumSettings: {
            merge: mergeField,
          },
          restrictions: {
            merge: mergeField,
          },
          postsV2: relayStylePagination(['order']),
        },
      },
      CircleOperations: {
        fields: {
          circleImageUploadUrl: {
            merge: mergeField,
          },
        },
      },
      Post: {
        fields: {
          replies: relayStylePagination(),
        },
      },
      // Program Activities
      DeepLink: {
        keyFields: ['type', 'url', 'id'],
      },
      GetActivityCompletionMetricsOutput: {
        fields: {
          patientIdsConnection: relayStylePagination(),
        },
      },
      GetProgressByCourseOutput: {
        fields: {
          progressConnection: relayStylePagination(),
        },
      },
    },
  });
}
